export default __webpack_public_path__ + "madfit-screen-second.47dedde2.png";